import { Link } from 'react-router-dom';

const About = () => (
  <section className="centered-section" style={{ textAlign: 'center' }}>
    <div className="translucent-box">
      <h2 className="main-heading">About Me</h2>
      <p className="main-paragraph">
        I’ve been sharpening knives since childhood, a craft I learned from my father and have refined over a lifetime. At The Golden Edge, every blade is restored and finished by hand using Japanese waterstones and careful attention to detail. My goal is simple: to deliver the best possible edge you’ll ever use.
      </p>
      <p style={{ marginTop: '1.5rem' }}>
        <Link to="/story" className="main-link">
          Click here to learn more
        </Link>
      </p>
      <p style={{ marginTop: '1.5rem' }}>
        <Link to="/gallery" className="main-link">
          Check out the Gallery &rarr;
        </Link>
      </p>
      <p style={{ marginTop: '1.5rem' }}>
        <Link to="/care" className="main-link">
          *** Never put your knife in the dishwasher. *** <br />
          Click here to read the rant on knife care &rarr;
        </Link>
      </p>
    </div>
  </section>
);

export default About;
